import moment from 'moment';

import 'moment/locale/pl';
moment.locale('pl');

export function dayFormat(props) {
	const date = moment(props); //.date(props);
	return date.isValid ? date.format('YYYY-MM-DD') : '';
}

export function minuteFormat(props) {
	const date = moment(props); //.date(props);
	return date.isValid ? date.format('YYYY-MM-DD HH:mm') : '';
}

export const secondsFormat = (props) => {
	const date = moment(props); //.date(props);
	return date.isValid ? date.format('YYYY-MM-DD HH:mm:ss') : '';
};